import React, { useEffect, useState } from 'react';
import BarChartIcon from '@material-ui/icons/BarChart';
import HomeIcon from '@material-ui/icons/Home';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import WarningIcon from '@material-ui/icons/Warning';
import { CentralProviderSidebar, usePermissions } from '@michelin/central-provider';
import { runningOnCanvas } from '@michelin/central-provider/dist/utils/canvas';
import { useHistory, useLocation, useParams } from 'react-router-dom';

function Icon({ file }: { file: string }) {
  const url = `${process.env.PUBLIC_URL}/static/images/preferencesIcons/${file}.svg`;
  return <img src={url} alt={file} style={{ width: 26, marginRight: 5, marginLeft: -3 }} />;
}

export default function SideBar() {
  const history = useHistory();
  const location = useLocation();
  const permissions = usePermissions();
  const { selectedAccount } = useParams<{ selectedAccount: string }>();
  const accountNumber = permissions.location?.customer_number || selectedAccount;
  const [selectedItem, setSelectedItem] = useState<string>('Home');

  useEffect(() => {
    const pathname = location.pathname;
    if (pathname.includes('/tire-wheel')) {
      setSelectedItem('Tire & Wheel Preferences');
    } else if (pathname.includes('/mechanical')) {
      setSelectedItem('Mechanical Preferences');
    } else if (pathname.includes('/contacts')) {
      setSelectedItem('Contacts');
    } else if (pathname.includes('/my-admin')) {
      setSelectedItem('My Admin Area');
    } else {
      setSelectedItem('Home');
    }
  }, [location.pathname]);

  const items: CentralProviderSidebar.Item[] = [
    { label: 'Home', icon: <HomeIcon />, selected: selectedItem === 'Home', onClick: () => setSelectedItem('Home') },
    {
      label: 'Request Service',
      icon: <WarningIcon />,
      selected: selectedItem === 'Request Service',
      onClick: () => setSelectedItem('Request Service'),
    },
    {
      label: 'LiveTrack',
      icon: <MyLocationIcon />,
      selected: selectedItem === 'LiveTrack',
      onClick: () => setSelectedItem('LiveTrack'),
    },
    {
      label: 'Fleet Business Insights',
      icon: <BarChartIcon />,
      selected: selectedItem === 'Fleet Business Insights',
      onClick: () => setSelectedItem('Fleet Business Insights'),
    },
    {
      label: 'Tire & Wheel Preferences',
      icon: <Icon file="bulk-order" />,
      selected: selectedItem === 'Tire & Wheel Preferences',
      onClick: () => history.push(`/${accountNumber}/tire-wheel`),
    },
    {
      label: 'Mechanical Preferences',
      icon: <Icon file="mechanical" />,
      selected: selectedItem === 'Mechanical Preferences',
      onClick: () => history.push(`/${accountNumber}/mechanical`),
    },
    {
      label: 'Contacts',
      icon: <Icon file="contacts" />,
      selected: selectedItem === 'Contacts',
      onClick: () => history.push(`/${accountNumber}/contacts`),
    },
    {
      label: 'My Admin Area',
      icon: <Icon file="all-preferences" />,
      selected: selectedItem === 'My Admin Area',
      onClick: () => history.push(`/${accountNumber}/my-admin`),
    },
  ];

  return (
    <CentralProviderSidebar
      items={items}
      showCopyright={!runningOnCanvas()}
      showLegalInformation={false}
      showApplicationSelector={!runningOnCanvas()}
    />
  );
}
